import React, { useState, forwardRef, useImperativeHandle, useCallback } from 'react';
import { Button, Modal, Input } from 'semantic-ui-react';
import QRCode from 'react-qr-code';
import toastr from 'toastr';
import styles from './QRCodePopup.module.css';
// import Joyn2Loader from '../Joyn2Loader';

const QRPopupComponent = forwardRef((props, ref) => {
  const [modalContent, handleModal] = useState({
    loading: false,
    open: false,
    taskDetails: {},
    header: 'Scan QR Code to download pdf',
  });
  const [qrValue, handleQrValue] = useState('');
  useImperativeHandle(ref, () => ({
    setModalContent({ loading = false, open = false, taskDetails = {}, header }) {
      handleModal((prevState) => ({ ...prevState, loading, open, taskDetails, header }));
    },
    setQRvalue(text) {
      handleQrValue(text);
    },
  }));

  const onClickCopy = useCallback(() => {
    navigator.clipboard.writeText(qrValue).then(
      () => {
        toastr.success('Copied!');
      },
      () => {
        toastr.error('Copy failed!');
      }
    );
  }, [qrValue]);

  return (
    <>
      <Modal size="small" open={modalContent?.open}>
        <Modal.Header>{modalContent.header}</Modal.Header>
        <Modal.Content>
          {modalContent?.loading ? (
            <div className="joyn2-loader" />
          ) : (
            <div style={{ height: 'auto', margin: '0 auto', maxWidth: 300, width: '100%' }}>
              <QRCode
                size={256}
                style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                value={qrValue}
                viewBox="0 0 256 256"
              />
            </div>
          )}
          <div className={styles.taskDetailsFlex}>
            <div className={styles.taskDetailsContainer}>
              <div className={styles.taskDetailRow}>
                {qrValue && (
                  <Input type="text" action>
                    <input value={qrValue} />
                    <Button icon="copy" onClick={onClickCopy} />
                  </Input>
                )}
              </div>
              <div className={styles.taskDetailRow}>
                <div className={styles.taskDetailLabel}>Task:</div>
                <div className={styles.taskDetailValue}>{modalContent?.taskDetails?.taskName}</div>
              </div>
              <div className={styles.taskDetailRow}>
                <div className={styles.taskDetailLabel}>Task #:</div>
                <div className={styles.taskDetailValue}>{modalContent?.taskDetails?.taskNumber}</div>
              </div>
              <div className={styles.taskDetailRow}>
                <div className={styles.taskDetailLabel}>Asset:</div>
                <div className={styles.taskDetailValue}>{modalContent?.taskDetails?.taskAsset}</div>
              </div>
              <div className={styles.taskDetailRow}>
                <div className={styles.taskDetailLabel}>Start Time</div>
                <div className={styles.taskDetailValue}>{modalContent?.taskDetails?.startTime}</div>
              </div>
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            onClick={() => {
              handleModal({ loading: false, open: false });
            }}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
});

export default QRPopupComponent;
